import React from "react";
import { FormHelperText, Grid, Icon, IconButton } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import FormField from "components/FormField/FormField";
import CrewOptions from "modules/crews/CrewOptions";
import CustomSelect from "components/Shared/CustomSelect/CustomSelect";

interface LabourFieldsProps {
  action: "create" | "update";
}

export default function LabourFields({ action }: LabourFieldsProps) {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  const inputKey = action === "create" ? "connect" : "sync";
  const crews = useFieldArray({
    control,
    name: `crews.${inputKey}` as const,
    keyName: "key",
  });

  return (
    <Grid item xs={12}>
      <CrewOptions>
        {({ crewOptions }) => (
          <>
            <MDBox display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6">Labor</MDTypography>
              <MDButton
                size="small"
                type="button"
                variant="contained"
                color="blue"
                onClick={() => crews.append({ id: null, quantity: 1 })}
              >
                Add labor
              </MDButton>
            </MDBox>

            {crews.fields.map((field, index) => (
              <Grid container key={field.key} spacing={1} mb={2} mt={1}>
                <Grid item xs={12} md={6}>
                  <CustomSelect
                    label="Crew"
                    control={control}
                    fullWidth
                    selectVariant="standard"
                    data={crewOptions}
                    name={`crews.${inputKey}.${index}.id`}
                    {...register(`crews.${inputKey}.${index}.id` as const)}
                  />
                  <FormHelperText error sx={{ marginLeft: "0px" }}>
                    {errors?.crews?.[inputKey]?.[index]?.id?.message as string}
                  </FormHelperText>
                </Grid>
                <Grid item xs={12} md={5.5}>
                  <FormField
                    type="number"
                    inputProps={{ min: 1, step: 1 }}
                    placeholder="Labor Quantity"
                    label="Quantity"
                    error={errors?.crews?.[inputKey]?.[index]?.quantity}
                    {...register(`crews.${inputKey}.${index}.quantity` as const, {
                      valueAsNumber: true,
                    })}
                  />
                </Grid>
                <Grid item xs={12} md={0.5}>
                  <MDBox display="flex" alignItems="center" justifyContent="flex-end" height="100%">
                    <IconButton
                      //@ts-ignore
                      color="negative"
                      onClick={() => crews.remove(index)}
                    >
                      <Icon fontSize="large" color="inherit">
                        delete
                      </Icon>
                    </IconButton>
                  </MDBox>
                </Grid>
              </Grid>
            ))}
            <FormHelperText error sx={{ marginLeft: "0px" }}>
              {(errors?.crews?.[inputKey]?.message as string) ?? ""}
            </FormHelperText>
          </>
        )}
      </CrewOptions>
    </Grid>
  );
}
